<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">Template Skin Details</h2>
                    </div>
                </CCol>
            </CRow>

            <div class='table-wrapper'>
                <header class="table-header">
                    <strong>Template Skin List</strong>
                </header>
                <div class="custom-table-wrapper">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th rowspan="2" style="width:15px" class="reg-list-font-size">{{this.getLanguage[["GL"]]["NO"]}}</th>
                                <th rowspan="2" style="width:20px" class="reg-list-font-size">Template<i @click="setSortTable('TN')" :class="setSortLogo('TN')" class="sortlogo"></i></th>
                                <th rowspan="2" style="width:50px" class="reg-list-font-size">Skin<i @click="setSortTable('SN')" :class="setSortLogo('SN')" class="sortlogo"></i></th>
                                <th rowspan="2" style="width:60px" class="reg-list-font-size">#Domain Using<i @click="setSortTable('DIU')" :class="setSortLogo('DIU')" class="sortlogo"></i></th>
                                <th rowspan="2" style="width:60px" class="reg-list-font-size">Added Date<i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i></th>
                                <th rowspan="2" style="width:20px" class="reg-list-font-size">Is New?<i @click="setSortTable('IN')" :class="setSortLogo('IN')" class="sortlogo"></i></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="arry_rsrl.length == 0">
                                <td colspan="100%">{{this.getLanguage['GL']['NR']}}</td>
                            </tr>
                            <tr v-for="(data,index) in arry_rsrl">
                                <td class="reg-list-font-size">{{ index+1 }}</td>
                                <td class="reg-list-font-size">{{data.TN}}</td>
                                <td class="reg-list-font-size">{{data.SN}}</td>
                                <td class="reg-list-font-size">{{ formatNumber(data.DIU, 0) }}</td>
                                <td class="reg-list-font-size">{{formatDateTime(data.CTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss", true)}}</td>
                                <td class="reg-list-font-size">{{data.IN}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { mapGetters, mapActions } from 'vuex'
    import Loading from 'vue-loading-overlay';
    import genericHelper from "@/modules/GenericHelper.js";
    import moment from "moment";
    import { constAccessType, loadingFullScreen } from '@/modules/Constant.js'

    export default {
        mixins: [genericHelper],
        components: {
            Loading
        },
        data() {
            return {
                bool_fullLoading: false, //Loading Visible
                bool_fullScreen: loadingFullScreen, //Full Screen
                int_RC: 100, //Row Count
                int_Page: 1,//current Page
                int_IC: 1, // Item Count
                str_tableSortBy: "TN", //(sort the table col name)
                bool_isSort: false,

                arry_rsrl: [], //hourly RS report list
            }
        },
        created() {
            this.getDataList();
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['getUserInfo']),
        },
        methods: {
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                var that = this;
                switch (SV) {
                    case 'TN':
                        this.arry_rsrl.sort(function (a, b) {
                            if (that.bool_isSort) {
                                return a.TN.localeCompare(b.TN);
                            }
                            else {
                                return b.TN.localeCompare(a.TN);
                            }
                        });
                        break;
                    case 'SN':
                        this.arry_rsrl.sort(function (a, b) {
                            if (that.bool_isSort) {
                                return a.SN.localeCompare(b.SN);
                            }
                            else {
                                return b.SN.localeCompare(a.SN);
                            }
                        });
                        break;
                    case 'DIU':
                        this.arry_rsrl.sort(function (a, b) {
                            if (that.bool_isSort) {
                                return parseFloat(a.DIU) - parseFloat(b.DIU);
                            }
                            else {
                                return parseFloat(b.DIU) - parseFloat(a.DIU);
                            }
                        });
                        break;
                    case 'CTS':
                        this.arry_rsrl.sort(function (a, b) {
                            if (that.bool_isSort) {
                                return a.CTS > b.CTS ? 1 : -1;
                            }
                            else {
                                return a.CTS < b.CTS ? 1 : -1;
                            }
                        });
                        break;
                    case 'IN':
                        this.arry_rsrl.sort(function (a, b) {
                            if (that.bool_isSort) {
                                return a.IN.localeCompare(b.IN);
                            }
                            else {
                                return b.IN.localeCompare(a.IN);
                            }
                        });
                        break;
                }
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            renderTemplateName(TemplateName) {
                if (TemplateName && TemplateName in this.getLanguage['TMPE'])
                    return this.getLanguage['TMPE'][TemplateName];
                else
                    return TemplateName;
            },
            getDataList() {
                var that = this;
                this.bool_fullLoading = true;
                this.getDataApi(`/api/ag/gtsd`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s && d.D) {
                            for (var i = 0; i < d.D.length; i++) {
                                d.D[i].TN = that.renderTemplateName(d.D[i].TN);
                            }

                            that.arry_rsrl = d.D;
                        }
                    });
            },
        },
        watch: {
        },

    }

</script>

<style>
    #registerSourceReport table tr td, #registerSourceReport table tr th {
        text-align: right;
    }
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/AgentSetting/TemplateSkinDetails.vue